export default __webpack_public_path__ + "static/metals-31147621724f43ee1a82579a955798fe.png";